module.exports = __webpack_public_path__ + "static/img/system-4.360aec2b.png";